(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/vanilla-sharing/dist/vanilla-sharing.umd.js
  var require_vanilla_sharing_umd = __commonJS({
    "node_modules/vanilla-sharing/dist/vanilla-sharing.umd.js"(exports, module) {
      (function(global, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global.VanillaSharing = {}));
      })(exports, function(exports2) {
        "use strict";
        var WIN_PARAMS = "scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0";
        function encodeParams(obj) {
          return Object.keys(obj).filter(function(k) {
            return typeof obj[k] !== "undefined" && obj[k] !== "";
          }).map(function(k) {
            return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(obj[k]));
          }).join("&");
        }
        function getFbFeedUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var fbAppId = options.fbAppId, url = options.url, redirectUri = options.redirectUri;
          if (!fbAppId) {
            throw new Error("fbAppId is not defined");
          }
          var params = encodeParams({
            app_id: fbAppId,
            display: "popup",
            redirect_uri: redirectUri,
            link: url
          });
          return "https://www.facebook.com/dialog/feed?".concat(params);
        }
        function fbFeed() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getFbFeedUrl(options), "_blank", WIN_PARAMS);
        }
        function getFbShareUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var fbAppId = options.fbAppId, url = options.url, hashtag = options.hashtag, redirectUri = options.redirectUri, quote = options.quote;
          if (!fbAppId) {
            throw new Error("fbAppId is not defined");
          }
          var params = encodeParams({
            app_id: fbAppId,
            display: "popup",
            redirect_uri: redirectUri,
            href: url,
            hashtag,
            quote
          });
          return "https://www.facebook.com/dialog/share?".concat(params);
        }
        function fbShare() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getFbShareUrl(options), "_blank", WIN_PARAMS);
        }
        function getFbButtonUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url;
          if (!url) {
            throw new Error("url is not defined");
          }
          var params = encodeParams({
            kid_directed_site: "0",
            sdk: "joey",
            u: url,
            display: "popup",
            ref: "plugin",
            src: "share_button"
          });
          return "https://www.facebook.com/sharer/sharer.php?".concat(params);
        }
        function fbButton2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getFbButtonUrl(options), "_blank", WIN_PARAMS);
        }
        function mail2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, title = options.title, description = options.description, image = options.image;
          var params = encodeParams({
            share_url: url,
            title,
            description,
            imageurl: image
          });
          return window.open("http://connect.mail.ru/share?".concat(params), "_blank", WIN_PARAMS);
        }
        function getEmailUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var to = options.to, url = options.url, title = options.title, description = options.description, subject = options.subject;
          var params = encodeParams({
            subject,
            body: "".concat(title || "", "\r\n").concat(description || "", "\r\n").concat(url || "")
          });
          return "mailto:".concat(to || "", "?").concat(params);
        }
        function email() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.location.assign(getEmailUrl(options));
        }
        function getOkUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, title = options.title, image = options.image;
          var params = encodeParams({
            url,
            title,
            imageUrl: image
          });
          return "https://connect.ok.ru/offer?".concat(params);
        }
        function ok2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getOkUrl(options), "_blank", WIN_PARAMS);
        }
        function getTelegramUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, title = options.title;
          var params = encodeParams({
            url,
            text: title
          });
          return "https://t.me/share/url?".concat(params);
        }
        function telegram2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getTelegramUrl(options), "_blank", WIN_PARAMS);
        }
        function getTwUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var title = options.title, url = options.url, _options$hashtags = options.hashtags, hashtags = _options$hashtags === void 0 ? [] : _options$hashtags;
          var params = encodeParams({
            text: title,
            url,
            hashtags: hashtags.join(",")
          });
          return "https://twitter.com/intent/tweet?".concat(params);
        }
        function tw2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getTwUrl(options), "_blank", WIN_PARAMS);
        }
        function reddit2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, title = options.title;
          var params = encodeParams({
            url,
            title
          });
          return window.open("https://www.reddit.com/submit?".concat(params), "_blank", WIN_PARAMS);
        }
        function pinterest2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var description = options.description, url = options.url, media = options.media;
          var params = encodeParams({
            url,
            description,
            media
          });
          return window.open("https://pinterest.com/pin/create/button/?".concat(params), "_blank", WIN_PARAMS);
        }
        function tumblr2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, title = options.title, caption = options.caption, _options$tags = options.tags, tags = _options$tags === void 0 ? [] : _options$tags, _options$posttype = options.posttype, posttype = _options$posttype === void 0 ? "link" : _options$posttype;
          var params = encodeParams({
            canonicalUrl: url,
            title,
            caption,
            tags: tags.join(","),
            posttype
          });
          return window.open("https://www.tumblr.com/widgets/share/tool?".concat(params), "_blank", WIN_PARAMS);
        }
        function isMobileSafari() {
          return !!window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
        }
        function mobileShare(link) {
          return isMobileSafari() ? window.open(link) : window.location.assign(link);
        }
        function getViberUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, title = options.title;
          if (!url && !title) {
            throw new Error("url and title not specified");
          }
          var params = encodeParams({
            text: [title, url].filter(function(item) {
              return item;
            }).join(" ")
          });
          return "viber://forward?".concat(params);
        }
        function viber() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return mobileShare(getViberUrl(options));
        }
        var VK_MAX_LENGTH = 80;
        function getVkUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var url = options.url, image = options.image, isVkParse = options.isVkParse;
          var description = options.description, title = options.title;
          if (description && description.length > VK_MAX_LENGTH) {
            description = "".concat(description.substr(0, VK_MAX_LENGTH), "...");
          }
          if (title && title.length > VK_MAX_LENGTH) {
            title = "".concat(title.substr(0, VK_MAX_LENGTH), "...");
          }
          var params;
          if (isVkParse) {
            params = encodeParams({
              url
            });
          } else {
            params = encodeParams({
              url,
              title,
              description,
              image,
              noparse: true
            });
          }
          return "https://vk.com/share.php?".concat(params);
        }
        function vk2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getVkUrl(options), "_blank", WIN_PARAMS);
        }
        function getWhatsappUrl() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var phone = options.phone, title = options.title, url = options.url;
          var params = encodeParams({
            text: [title, url].filter(function(item) {
              return item;
            }).join(" "),
            phone
          });
          return "https://api.whatsapp.com/send?".concat(params);
        }
        function whatsapp2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return window.open(getWhatsappUrl(options), "_blank", WIN_PARAMS);
        }
        function linkedin2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var title = options.title, url = options.url, description = options.description;
          var params = encodeParams({
            title,
            summary: description,
            url
          });
          return window.open("https://www.linkedin.com/shareArticle?mini=true&".concat(params), "_blank", WIN_PARAMS);
        }
        function messenger() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var fbAppId = options.fbAppId, url = options.url;
          if (!fbAppId) {
            throw new Error("fbAppId is not defined");
          }
          var params = encodeParams({
            app_id: fbAppId,
            link: url
          });
          return window.location.assign("fb-messenger://share?".concat(params));
        }
        function line2() {
          var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var title = options.title, url = options.url;
          if (!url) {
            throw new Error("url is not defined");
          }
          var params = encodeURIComponent("".concat(url));
          if (title) {
            params = "".concat(encodeURIComponent("".concat(title, " "))).concat(params);
          }
          return window.open("https://line.me/R/msg/text/?".concat(params), "_blank", WIN_PARAMS);
        }
        exports2.email = email;
        exports2.fbButton = fbButton2;
        exports2.fbFeed = fbFeed;
        exports2.fbShare = fbShare;
        exports2.getEmailUrl = getEmailUrl;
        exports2.getFbButtonUrl = getFbButtonUrl;
        exports2.getFbFeedUrl = getFbFeedUrl;
        exports2.getFbShareUrl = getFbShareUrl;
        exports2.getOkUrl = getOkUrl;
        exports2.getTelegramUrl = getTelegramUrl;
        exports2.getTwUrl = getTwUrl;
        exports2.getViberUrl = getViberUrl;
        exports2.getVkUrl = getVkUrl;
        exports2.getWhatsappUrl = getWhatsappUrl;
        exports2.line = line2;
        exports2.linkedin = linkedin2;
        exports2.mail = mail2;
        exports2.messenger = messenger;
        exports2.ok = ok2;
        exports2.pinterest = pinterest2;
        exports2.reddit = reddit2;
        exports2.telegram = telegram2;
        exports2.tumblr = tumblr2;
        exports2.tw = tw2;
        exports2.viber = viber;
        exports2.vk = vk2;
        exports2.whatsapp = whatsapp2;
      });
    }
  });

  // app/scripts/common/function/socialShare.js
  var import_vanilla_sharing = __toESM(require_vanilla_sharing_umd(), 1);
  var { addEvent } = theme;
  var shareButton = {
    pinterest: (url, title) => {
      (0, import_vanilla_sharing.pinterest)({
        url
      });
    },
    twitter: (url, title) => {
      (0, import_vanilla_sharing.tw)({
        url,
        title
      });
    },
    facebook: (url, title) => {
      (0, import_vanilla_sharing.fbButton)({
        url
      });
    },
    reddit: (url, title) => {
      (0, import_vanilla_sharing.reddit)({
        url,
        title
      });
    },
    tumblr: (url, title) => {
      (0, import_vanilla_sharing.tumblr)({
        url,
        title
      });
    },
    vk: (url, title) => {
      (0, import_vanilla_sharing.vk)({
        url,
        title
      });
    },
    ok: (url, title) => {
      (0, import_vanilla_sharing.ok)({
        url,
        title
      });
    },
    mail: (url, title) => {
      (0, import_vanilla_sharing.mail)({
        url,
        title
      });
    },
    linkedin: (url, title) => {
      (0, import_vanilla_sharing.linkedin)({
        url,
        title
      });
    },
    whatsapp: (url, title) => {
      (0, import_vanilla_sharing.whatsapp)({
        url,
        title
      });
    },
    telegram: (url, title) => {
      (0, import_vanilla_sharing.telegram)({
        url,
        title
      });
    },
    line: (url, title) => {
      (0, import_vanilla_sharing.line)({
        url,
        title
      });
    }
  };
  addEvent("click", ".js-social-share", (e) => {
    e.preventDefault();
    const link = e.target.closest(".js-social-share");
    const type = link.dataset.type;
    shareButton[type](link.href, link.title);
  });

  // app/scripts/social-share-component.js
  customElements.define("component-copylink", class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.btn = this.querySelector("button");
      this.btn.addEventListener("click", () => {
        this.copyText = this.querySelector("input");
        this.copyText.select();
        this.copyText.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(this.copyText.value);
        alert("Copied to clipboard");
      });
    }
  });
})();
